import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router';
import Toggle from 'react-toggle';
import classnames from 'classnames';
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ModalDelete from '../../component/smart/modals/ModalDelete'
import RolloutBlacklistModal from './RolloutBlacklistModal'
import SearchBar from '../../component/dump/menuComponents/SearchBar'
import FleetAdminFirmwareBSTable from './FleetAdminFirmwareBSTable'
import GreyHeader from '../../component/dump/menuComponents/GreyHeader';

import { defaultTableOptions, expandTableOptions } from '../../component/helpers/table'
import { dvType, isInternalUser } from '../../component/helpers/constants';
import { getAvailableFirmwareList, applyFirmwareAction, pushFirmwareFile, deleteFirmware, sendNotification, changeFirmwareViewingOptions } from '../../action/FleetAdminActions'
import { getDevicesList } from '../../action/DeviceActions'
import { apiCall, apiCallGet } from '../../action/RouterActions'

import '../../component/dump/menuComponents/menuComponents.sass'
import CustomButton from '../../component/CustomButton'

const Firmware = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'firmwaresPage.firmware' });
	const { user, company, toggleLoader } = props;
	const userRole = user.roles[0];

	const file_ref = useRef(null);
	const release_note_ref = useRef(null);
	const refs = { file: file_ref, release_note: release_note_ref };

	const [devices, setDevices] = useState([]);
	const [groups, setGroups] = useState([]);
	const [firmwares, setFirmwares] = useState([]);
	const [data, setData] = useState({
		file: '',
		release_note: ''
	});
	const [searchText, setSearchText] = useState('');
	const [errMessage, setErrMessage] = useState({
		file: '',
		release_note: ''
	});
	const [selectedFirmwareObj, setSelectedFirmwareObj] = useState(null);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showConfirmMandatoryModal, setShowConfirmMandatoryModal] = useState(false);
	const [showRolloutBlacklistModal, setShowRolloutBlacklistModal] = useState(false);
	const [blacklistCompaniesId, setBlacklistCompaniesId] = useState([])
	const [DVType, setDVType] = useState('dv6');
	const isProd = location.hostname === 'fleet.roscolive.com';
	const DV7access = (!isProd && !['S3 buckets partner'].includes(company.partner)) || (isProd && ['DV7 Rosco Testing'].includes(company.partner));

	useEffect(() => {
		switch (userRole) {
			case 'system_admin':
			case 'customer_service':
			case 'sales_demo':
			case 'partner':
			case 'partner_view':
			case 'custom_partner':
				if (company.company_id) {
					getFleetDevices(company.company_id);
				}
				break;
			case 'fleet_maintainer':
			// FWSD-7901 Fleet manager role does not have access to the Firmware page
			// case 'fleet_manager':
			case 'storage_manager':
			case 'custom_user':
				if (company.company_id) {
					getFleetDevices();
				}
				break;
			default:
				break;
		}
	}, [company.company_id]);

	const getFleetDevices = (/*argCompanyName = null, argPartnerName = null,*/ argCompanyId = null) => {
		toggleLoader(true);
		const companyId = argCompanyId || company.company_id;
		// const companyName = argCompanyName || company.name || user.company_name;
		// const partnerName = argPartnerName || company.partner;
		const requestArray = []

		// requestArray.push(getAllDevices(userRole, companyName, partnerName, null, true));
		// requestArray.push(getDevicesList(companyId, 'latest_hdderror,data_usage,ignition,sd_status,channel_status,driver,firmware_version,firmware_status'));
		requestArray.push(getDevicesList(companyId, 'firmware_status'))
		requestArray.push(apiCallGet('/companies/firmware/blacklist'))

		if (!['partner', 'custom_partner', 'fleet_manager'].includes(userRole)) {
			requestArray.push(getAvailableFirmwareList(userRole))
		}
		Promise.all(requestArray)
			.then(
				(res) => {
					console.log('getFleetDevices PromiseAll res: ', res);
					const { devices } = res[0].data.response
					const blacklist = _.get(res[1], 'data.response', []).map(({ company_id }) => company_id)

					const result = [];
					devices.map((item) => {
						if (!item.group_name) {
							item.group_name = t('withoutGroup');
						}

						if (!item.vehicle_name) {
							item.vehicle_name = item.device_id;
						}

						return item;
					})

					const groups = _.groupBy(devices, device => device.group_name);
					const keys = Object.keys(groups); // keys - groups name
					// keys = _.sortBy(keys, function(num){ return num.toLowerCase(); });

					for (let i = 0; i < keys.length; i++) {
						const k = keys[i];
						result.push({ id: i, group_name: k, expand: groups[k], userRole });
					}

					const all_devices_id = [];
					devices.forEach(device => all_devices_id.push(device.device_id));

					setDevices(devices);
					setGroups(result);
					setBlacklistCompaniesId(blacklist)

					// FWSD-7334, The /available_firmware API is available for ['partner', 'custom_partner', 'fleet_manager'] just if current company exists in Rollout Blacklist
					if (res[2]) {
						const newFirmwares = res[2].data.response.firmwares
						// setFirmwares(newFirmwares.sort((a, b) => (a.id === 0) ? -1 : b.id - a.id))
						const getLast3 = (prefix, ext) => (
							newFirmwares
								.filter(f => 
									f.version &&
									f.version.startsWith(prefix) &&
									f.version.endsWith(ext)
								)
								.sort((a, b) => b.id - a.id)
								.slice(0, 3)
						)
						setFirmwares([
							...getLast3("dv6_v", ".fw"),
							...getLast3("dv6_t", ".fw"),
							...getLast3("dv6", ".mcu"),
							...getLast3("dvxc4", ".fw"),
							...getLast3("dv7", ".fw"),
							...getLast3("dv7", ".mcu"),
						])
					}
					else if (['partner', 'custom_partner', 'fleet_manager'].includes(userRole) && blacklist.includes(companyId)) {
						getAvailableFirmwareList(userRole)
							.then(res => {
								const newFirmwares = res.data.response.firmwares
								setFirmwares(newFirmwares.sort((a, b) => (a.id === 0) ? -1 : b.id - a.id))
							})
							.catch((errorAvFW) => {
								console.log('getAvailableFirmwareList error: ', errorAvFW)
								let errDescription = i18n.t('errorMessage.errDescription');
								if (errorAvFW.response.data.response.error) {
									errDescription = errorAvFW.response.data.response.error
								}
								toastr.error(errDescription)
							})
					}

					toggleLoader(false);
				},
				(error) => {
					toggleLoader(false);
					console.log('getFleetDevices PromiseAll error: ', error.response, error)

					setFirmwares([]);
					setDevices([]);
					setGroups([]);

					let errDescription = i18n.t('errorMessage.errDescription');
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription);
				},
			)
			.catch((error) => {
				toggleLoader(false);
				console.log('getFleetDevices PromiseAll catch error: ', error);

				setFirmwares([]);
				setDevices([]);
				setGroups([]);

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	};

	const checkForm = (data, e) => {
		let error = false;

		if (!data.version) {
			error = true;
			toastr.error(t('selectFirmware'));
		}

		if (!data.device_id) {
			error = true;
			toastr.error(t('noSelectedDevices'));
		}

		return error;
	}

	const applyFirmware = (e) => {
		e.preventDefault();
		const restart = data.restart || false;

		let selectedDevices = []
		groups.forEach((group) => {
			// if selected dv6 firmware then will update just dv6 devices,
			// else if selected dv4 firmware then will update just dv4 devices
			const groupDevices = group.expand.filter((item) => {
				if (data.selectedFirmware && data.selectedFirmware.includes('dv6') && dvType(item) === 'dv6') {
					return item
				}
				if (data.selectedFirmware && data.selectedFirmware.includes('dv7') && dvType(item) === 'dv7') {
					return item
				}
				if (data.selectedFirmware && data.selectedFirmware.includes('dv4') && dvType(item) === 'dv4') {
					return item
				}
			});

			selectedDevices = [...selectedDevices, ...groupDevices]
		})

		const params = {
			version: data.selectedFirmware,
			device_id: selectedDevices.map(({ device_id }) => device_id).join(','),
			restart
		}

		const error = checkForm(params, e);
		if (!error) {
			toggleLoader(true);
			applyFirmwareAction(userRole, params)
				.then((res, err) => {
					console.log('!applyFirmware res: ', res.data.response);
					toggleLoader(false);
					if (res.status === 200) {
						getFleetDevices();
						toastr.success('Success', t('firmwareUpgradeSent'));
					}
					if (err) {
						console.log('!applyFirmware err', err);
					}
				})
				.catch((errorApply) => {
					toggleLoader(false);
					console.log('!applyFirmware error: ', errorApply.response, errorApply);
					let errDescription = i18n.t('errorMessage.errDescription');
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription);
				});
		}
	};

	const handleInputChange = (event) => {
		const { target } = event;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const { name } = target;
		setData({ ...data, [name]: value });
	};

	const onFileChange = (event) => {
		const { value } = event.target
		const file = event.target.files[0] || '';

		data.file = file

		setData(data);

		let i
		if (value.lastIndexOf('\\')) {
			i = value.lastIndexOf('\\') + 1;
		} else {
			i = value.lastIndexOf('/') + 1;
		}
		const filename = value.slice(i);
		uploadFileNameClear(filename);
	}

	const checkUploadFirmware = (data) => {
		let error = false;

		for (let i in data) {
			if ((data[i] == '' || data[i] == 'undefined') && refs[i]) {
				error = true
				errMessage[i] = t('enterYour') + i.replaceAll('_', ' ');
			} else if (errMessage[i]) {
				errMessage[i] = null
			}
		}

		if (!errMessage.file && (!new Set(['fw', 'bin', 'mcu']).has(data.file.name.split('.').pop()))) {
			error = true
			errMessage.file = t('errFile') + '".fw", ".bin" or ".mcu"'
		}

		setErrMessage(errMessage);
		return error;
	}

	const uploadFirmware = (e) => {
		e.preventDefault()
		const params = {
			file: data.file,
			release_note: data.release_note
		};
		const error = checkUploadFirmware(params, e)

		if (!error) {
			toggleLoader(true);
			pushFirmwareFile(userRole, params)
				.then((res, err) => {
					console.log('!downloadConfig uploadConfig res', res, err)
					toggleLoader(false);
					getFleetDevices();
					uploadFileNameClear();

					setData({ ...data, file: '' })
					toastr.success('Success', t('firmwareUploaded'))
				})
				.catch((errorUpload) => {
					toggleLoader(false);
					console.log('!uploadConfig error: ', errorUpload.response, errorUpload)

					uploadFileNameClear()
					setData({ ...data, file: '' })

					let errDescription = i18n.t('errorMessage.errDescription');
					if (errorUpload.response.data.response.error) {
						errDescription = errorUpload.response.data.response.error
					}
					toastr.error(errDescription);
				})
		}
		else {
			toastr.error(errMessage.file || errMessage.release_note || i18n.t('errorMessage.errDescription'))
		}
	};

	const uploadFileNameClear = (filename) => {
		const upload_file_name = document.getElementById('upload-form-label');
		upload_file_name.innerHTML = filename || '';
	};

	const percentageFormatter = (cell) => {
		return cell ? cell.toFixed(2) : 0
	};

	const viewingFormatter = (cell, row) => {
		const { version, updated_devices, total_devices, total_updating } = row
		const percentage = total_devices ? (updated_devices / total_devices * 100) : 0
		if (version.includes('_v')) {
			return (
				<div>
					{/* <select
						placeholder="select"
						className="form-control"
						name={version}
						id="firmwareViewingOptions"
						style={{ height: '25px', padding: '2px 12px' }}
						value={cell}
						onChange={this.firmwareViewingOptions}
					>
						<option value="0">Test Firmware</option>
						<option value="1">Public Mandatory</option>
						<option value="2">Public Patch</option>
					</select> */}
					{isInternalUser(userRole) &&
						<CustomButton variant="primary" onClick={() => firmwareViewingOptions(version)}>{t('beginRollout')}</CustomButton>
					}
					{total_updating !== 'no_updates' && (
						<div className="progress-wrapper">
							<ProgressBar now={percentage} variant={['active', 'stop'].includes(total_updating) ? 'info' : 'success'} />
							{['active', 'stop'].includes(total_updating)
								? <div className="progress-status">{`${updated_devices}/${total_devices} ${t('vehiclesUpToDate')}`}</div>
								: <div className="progress-status">{t('rolloutComplete')}<br /><div>{percentage}% {t('vehiclesUpdated')}</div></div>
							}
						</div>
					)}
				</div>
			)
		}

		return ''
	};

	const deleteFormatter = (cell, row) => {
		const { total_updating } = row;

		// Does not allow to remove the No Firmware firmware
		if (row.id === 0) {
			return ''
		}

		return (
			<div className="actions-wrapper">
				<CustomButton variant="link" prefix="flexBtn" onClick={e => openDeleteModal(e, row)}>
					<i style={{ color: 'red' }} className="fas fa-times-circle" />
					{t('btnDelete')}
				</CustomButton>
				{isInternalUser(userRole) && total_updating === 'active' && (
					<CustomButton variant="link" prefix="flexBtn" onClick={e => handleStopRolloutClick(e, row)}>
						<i style={{ color: 'red' }} className="far fa-stop-circle" />
						{t('btnStopRollout')}
					</CustomButton>
				)}
				{isInternalUser(userRole) && total_updating === 'stop' && (
					<CustomButton variant="link" prefix="flexBtn" onClick={e => handleResumeRolloutClick(e, row)}>
						<i className="far fa-play-circle" />
						{t('btnResumeRollout')}
					</CustomButton>
				)}
			</div>
		)
	};

	const openDeleteModal = (e, row) => {
		e.preventDefault();
		setSelectedFirmwareObj(row);
		setShowDeleteModal(true);
	};

	const closeDeleteModal = () => {
		setShowDeleteModal(false);
		setShowConfirmMandatoryModal(false);
		setSelectedFirmwareObj(null);
	};

	const deleteFirmwareModal = () => {
		toggleLoader(true);
		deleteFirmware(selectedFirmwareObj)
			.then((res) => {
				console.log('!deleteFirmwareModal res', res);
				toggleLoader(false);

				// if (selectedFirmwareObj.is_public === 1) {
				apiCall('POST', '/device/firmware/totalupdate/cancel?firmware={version}', { version: selectedFirmwareObj.version })
					.then((resCancel) => {
						console.log('!deleteFirmwareModal cancel res: ', resCancel)
					})
					.catch((error) => {
						console.log('!deleteFirmwareModal cancel error: ', error.response, error)
					})
				// }

				getFleetDevices();
				setSelectedFirmwareObj(null);
				setShowDeleteModal(false);

				toastr.success('', t('firmwareDeleted'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!deleteFirmwareModal error:', error);

				setSelectedFirmwareObj(null);
				setShowDeleteModal(false);

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			});
	};

	const handleStopRolloutClick = (e, row) => {
		e.preventDefault()
		const { version } = row

		apiCall('POST', '/device/firmware/totalupdate/stop?firmware={version}', { version })
			.then((res) => {
				console.log('!handleStopRolloutClick res: ', res)
				const { total_devices, updated_devices } = res.data.response
				const arr = firmwares.map((item) => {
					if (item.version === version) {
						item.total_updating = 'stop'
						item.total_devices = total_devices
						item.updated_devices = updated_devices
					}
					return item
				})
				setFirmwares(arr);
				toastr.success('', t('firmwareUpdateStopped'));
			})
			.catch((error) => {
				console.log('!handleStopRolloutClick error: ', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const handleResumeRolloutClick = (e, row) => {
		e.preventDefault()
		const { version } = row;

		apiCall('POST', '/device/firmware/totalupdate/resume?firmware={version}', { version })
			.then((res) => {
				console.log('!handleResumeRolloutClick res: ', res)
				const { total_devices, updated_devices } = res.data.response
				const arr = firmwares.map((item) => {
					if (item.version === version) {
						item.total_updating = 'active'
						item.total_devices = total_devices
						item.updated_devices = updated_devices
					}
					return item
				})
				setFirmwares(arr);
				toastr.success('', t('firmwareUpdateContinues'));
			})
			.catch((error) => {
				console.log('!handleResumeRolloutClick error: ', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const sendNotificationToUsers = () => {
		toggleLoader(true);
		sendNotification()
			.then((res) => {
				console.log('!sendNotificationToUsers res', res);
				toggleLoader(false);

				toastr.success('', t('notificationSent'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!sendNotificationToUsers error', error);

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			});
	}

	const expandComponent = (row) => (
		<FleetAdminFirmwareBSTable
			data={row}
			blacklistCompaniesId={blacklistCompaniesId}
			firmwares={firmwares.filter(e => e.version.includes(DVType.replace('dv4', 'dvxc4')))}
		/>
	);

	const firmwareViewingOptions = (name) => {
		setSelectedFirmwareObj({ ...selectedFirmwareObj, version: name });
		setShowConfirmMandatoryModal(true);
	};

	const confirmPublicMandatory = () => {
		const { version } = selectedFirmwareObj;

		toggleLoader(true);
		changeFirmwareViewingOptions(version, '1')
			.then((res, err) => {
				console.log('!confirmPublicMandatory res: ', res, err);
				toggleLoader(false);

				// apiCall('POST', '/device/firmware/totalupdate/start?firmware={version}&company_id={companyId}', { version, companyId: company.company_id })
				apiCall('POST', '/device/firmware/totalupdate/start?firmware={version}', { version })
					.then((resStart, errStart) => {
						console.log('!confirmPublicMandatory start res: ', resStart)
						const { total_devices } = resStart.data.response
						const arr = firmwares.map((item) => {
							if (item.version === version) {
								// item.is_public = 1
								item.total_updating = 'active'
								item.total_devices = total_devices
								item.updated_devices = 0
							}
							return item
						})
						setFirmwares(arr);
					})
					.catch((error) => {
						console.log('!confirmPublicMandatory start error: ', error.response, error)
					})

				toastr.success('', t('firmwareSettingsChanged'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!confirmPublicMandatory error: ', error.response, error);

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			});

		closeDeleteModal();
	};

	const dataSearch = (e) => {
		const result = [];
		const allDevicesId = [];
		const value = e.target.value.toLowerCase();

		const devicesFiltered = devices.filter((device) => {
			return (
				(device.vehicle_name && device.vehicle_name.toLowerCase().includes(value))
				|| (device.device_id && device.device_id.toString().toLowerCase().includes(value))
			)
		});

		const availableGroups = _.groupBy(devicesFiltered, device => device.group_name);
		const keys = Object.keys(availableGroups); // keys - groups name

		for (let i = 0; i < keys.length; i += 1) {
			const k = keys[i];
			result.push({ id: i, group_name: k, expand: availableGroups[k], userRole: user.roles[0] });
		}

		devicesFiltered.forEach(device => allDevicesId.push(device.device_id));

		setGroups(result);
		setSearchText(value);
	};

	const { file, release_note } = errMessage;
	const readOnly = (['sales_demo', 'partner', 'partner_view', 'custom_partner', 'fleet_manager'].includes(userRole))

	const firmwareList = () => {
		const option = [];
		if (firmwares) {
			firmwares.map((elem, index) => {
				if (elem.id !== 0) { // hides the No Firmware firmware version
					option[index] = (<option key={elem.id} value={elem.version}>{elem.version}</option>)
				}
			});
			return (
				<select placeholder="select" className="form-control" name="selectedFirmware" id="selectedFirmware" style={{ width: '250px', appearance: 'auto' }} onChange={handleInputChange}>
					<option />
					{option}
				</select>
			);
		}
	};

	const formatGroupName = (cell, row) => {
		const size = row.expand.length;
		let amount = t('vehicles');

		if (size === 1) {
			amount = t('vehicle');
		}

		return `${row.group_name} (${size} ${amount})`;
	};

	const filteredGroups = groups.map(group => ({ ...group, expand: group.expand.filter(item => (dvType(item) === DVType)) })).filter(e => (e.expand.length));

	return (
		<div className="firmware-page">
			<GreyHeader title={t('titleFirmware')} />
			<main className="main-content-block">
				<div className="fleet-admin-firmware">
					<div className="col-xs-12 main-content-background-border">
						<div className="firmware-container-mobile manage-users-table manage-firmware-page-table" style={{ clear: 'both' }}>
							{
								devices.length < 1
									? (
										<div className="col-xs-12">
											<h5>{t('noVehiclesCompany')}</h5>
											{
												(['system_admin', 'customer_service'].indexOf(userRole) > -1)
												&& <p><Link to="/managevehicles">{t('addVehicleGroup')}</Link></p>
											}
										</div>
									)
									: (
										<div className="firmware-wrapper">
											{/* The "Search vehicles" block */}
											<div className="col-md-6 col-xs-12 firmware-mobile-wrapper" style={{ marginBottom: '15px', padding: "0 25px" }}>
												<SearchBar
													term={searchText}
													onSearch={dataSearch}
													classSize="col-md-10"
													placeholder={t('placeholderSearchVehicles')}
												/>
											</div>

											{/* The "Firmware Update for all devices in all groups" block */}
											{!readOnly
												&& (
													<div className="col-md-6 col-xs-12 firmware-mobile-wrapper" style={{ display: "flex", flexDirection: "column", padding: "0 25px" }}>
														<div className="firmware-inner col-xs-12"><h5>{t('firmwareUpdateAll')}</h5></div>
														<div className="firmware-inner col-xs-12">
															<div className="fields-container" style={{ float: 'left', marginRight: '20px', marginTop: '4px' }}>
																{firmwareList()}
															</div>
															<div className="fields-container" style={{ float: 'left', marginTop: '4px' }}>
																<CustomButton variant="primary" onClick={applyFirmware}>{t('btnUpgrade')}</CustomButton>
															</div>
														</div>
														<div className="firmware-inner col-xs-12" style={{ paddingTop: '15px' }}>
															<p><strong>{t('firmwareInner1')}</strong></p>
															<p><strong>{t('firmwareInner2')}</strong></p>
															<label>
																<span style={{ paddingRight: '10px' }}>{t('noReboot')}</span>
																<Toggle
																	name="restart"
																	onChange={e => handleInputChange(e)}
																/>
																<span style={{ paddingRight: '15px' }}>{t('rebootImmediately')}</span>
															</label>
														</div>
													</div>
												)
											}
										</div>
									)
							}
							<div style={{ clear: 'both', margin: '10px 0 20px 0px' }}>
								<div className="row mobile-border" style={{ borderTop: '15px solid #F0F0F0' }} />
							</div>
							<div className="toggle-wrapper button-group mb-20">
								<div className="toggle-buttons">
									<CustomButton
										variant='toggle'
										active={DVType === 'dv6'}
										value="dv6"
										onClick={() => setDVType('dv6')}
									>
										DV6
									</CustomButton>
									{DV7access &&
										<CustomButton
											variant='toggle'
											active={DVType === 'dv7'}
											value="dv7"
											onClick={() => setDVType('dv7')}
										>
											DV7
										</CustomButton>}
									<CustomButton
										variant='toggle'
										active={DVType === 'dv4'}
										value="dv4"
										onClick={() => setDVType('dv4')}
									>
										DV4
									</CustomButton>
								</div>
							</div>
							{/* Table of vehicles with installed firmwares */}
							<BootstrapTable
								data={filteredGroups}
								{...expandTableOptions}
								expandComponent={expandComponent}
							>
								<TableHeaderColumn dataField="id" isKey hidden>{t('headerID')}</TableHeaderColumn>
								<TableHeaderColumn dataField="group_name" width="100%" dataFormat={formatGroupName}>{t('headerGroupName')}</TableHeaderColumn>
							</BootstrapTable>


							{userRole === 'system_admin'
								&& (
									<div className="firmware-admin-table-wrapper">
										<div className="row mobile-border" style={{ borderTop: '15px solid #F0F0F0', margin: '20px -30px 5px' }} />
										<div className="firmware-portal-container">
											<h5>{t('titleFirmwarePortal')}</h5>
											<div className="firmware-upload-container">
												<div>
													<div className={classnames('upload-file-form', { 'has-error': file })}>
														<div id="upload-form-label" />
														<div className="selectbutton">{t('selectFile')}</div>
														<input type="file" ref={file_ref} name="file" id="upload-input" onChange={onFileChange} />
														{file && <span className="help-block">{file}</span>}
													</div>
													<CustomButton variant="secondary" onClick={uploadFirmware}>{t('btnUpload')}</CustomButton>
												</div>
												<CustomButton variant="primary-outline" onClick={() => setShowRolloutBlacklistModal(true)}>{t('btnRolloutBlacklist')} </CustomButton>
											</div>
										</div>
										<div className="firmware-note-container">
											<label htmlFor="release_note" className="control-label">{t('labelReleaseNote')}</label>
											<div className={classnames('form-group', { 'has-error': errMessage.release_note })}>
												<textarea name="release_note" ref={release_note_ref} className="release-note" onChange={handleInputChange} />
												{errMessage.release_note &&
													<span className="help-block">{errMessage.release_note}</span>
												}
											</div>
										</div>

										<BootstrapTable
											data={firmwares}
											{...defaultTableOptions}
										>
											<TableHeaderColumn dataField="id" isKey hidden>{t('headerFirmwarePortalID')}</TableHeaderColumn>
											<TableHeaderColumn width="15%" dataField="version">{t('headerFirmwareVersion')}</TableHeaderColumn>
											<TableHeaderColumn width="35%" dataField="release_note" tdStyle={{ whiteSpace: 'normal' }}>{t('headerReleaseNote')}</TableHeaderColumn>
											<TableHeaderColumn width="10%" dataField="devices_percentage" dataFormat={percentageFormatter} dataSort>% {t('headerDevices')}</TableHeaderColumn>
											<TableHeaderColumn width="20%" dataField="is_public" dataFormat={viewingFormatter}>{t('headerRolloutFirmware')}</TableHeaderColumn>
											<TableHeaderColumn width="20%" dataField="url" dataFormat={deleteFormatter}>{t('headerActions')}</TableHeaderColumn>
										</BootstrapTable>

										<div className="row mobile-border" style={{ borderTop: '15px solid #F0F0F0', margin: '20px -30px 5px' }} />

										<div className="firmware-send-container">
											<h5>{t('sendNotificationUsers')}</h5>

											<CustomButton variant="primary" onClick={sendNotificationToUsers}>{t('sendNotification')}</CustomButton>
										</div>
									</div>
								)
							}
						</div>
					</div>
				</div>

				{showDeleteModal
					&& (
						<ModalDelete
							content={`${t('modalDeleteContent1')} "${selectedFirmwareObj.version}" ?`}
							closeModal={closeDeleteModal}
							deleteModal={deleteFirmwareModal}
						/>
					)
				}

				{showConfirmMandatoryModal
					&& (
						<ModalDelete
							title={t('modalDeleteTitle')}
							content={t('modalDeleteContent2')}
							deleteBtnName={t('deleteBtnName')}
							closeModal={closeDeleteModal}
							deleteModal={confirmPublicMandatory}
						/>
					)
				}

				{showRolloutBlacklistModal
					&& (
						<RolloutBlacklistModal
							onHide={() => setShowRolloutBlacklistModal(false)}
							userRole={userRole}
							blacklistCompaniesId={blacklistCompaniesId}
							loadFirmwareBlacklist={getFleetDevices}
						/>
					)
				}
			</main>
		</div>
	)
}

Firmware.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = ({ user, company }) => ({
	user: user.user,
	company: company.company,
});

const mapDispatchToProps = (dispatch) => {
	return {
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Firmware);
